import React from "react"
import {IcomoonIconName} from "../../Icon/icons"
import {noop} from "lodash"

type FilterDropdownMenuProps = {
	toggleAll: typeof noop
	toggleNone: typeof noop
	isSearchable: boolean
	searchBox: JSX.Element
	buttons: JSX.Element[]
	customFilters?: {name: string; filterFn: () => void}[]
	buttonsLength: number
	singleSelect?: boolean
}
export function FilterDropdownMenu({
	toggleAll,
	toggleNone,
	isSearchable,
	searchBox,
	buttons,
	customFilters,
	buttonsLength,
	singleSelect = false,
}: FilterDropdownMenuProps & {filterIcon?: IcomoonIconName}) {
	const selectAllLimit = 50
	return (
		<div className="dropdown-menu filter-dropdown-menu" id="dropdown-menu" role="menu">
			<div className="dropdown-content">
				{isSearchable ? <div className="dropdown-item">{searchBox}</div> : null}
				<div className="panel is-shadowless is-marginless limeted-height">{buttons}</div>
				<hr className="dropdown-divider" />
				<div className="dropdown-item">
					<div className="button-grid">
						{!singleSelect && buttonsLength <= selectAllLimit && (
							<button className="button is-light light-wide-button" onClick={(_) => toggleAll()}>
								Select all
							</button>
						)}
						<button className="button is-light light-wide-button" onClick={(_) => toggleNone()}>
							None
						</button>
						{!singleSelect &&
							customFilters?.map((customFilter) => (
								<button
									key={customFilter.name}
									className="button is-light light-wide-button"
									onClick={(_) => customFilter.filterFn()}
								>
									{customFilter.name}
								</button>
							))}
					</div>
				</div>
			</div>
		</div>
	)
}
